/**
 * SHA-256 hex digest via Web Crypto. Resolves to null when the value is empty
 * or Web Crypto is unavailable (non-secure context / SSR).
 * @param {string} value
 * @returns {Promise<string|null>}
 */
export const sha256Hex = async (value) => {
  if (!value || typeof window === 'undefined' || !window.crypto?.subtle) return null

  const bytes = new TextEncoder().encode(String(value))
  const digest = await window.crypto.subtle.digest('SHA-256', bytes)
  return Array.from(new Uint8Array(digest))
    .map((b) => b.toString(16).padStart(2, '0'))
    .join('')
}

export default sha256Hex
